import { TOOL_DURATION_MS } from '../../../../components/AgentRow'
import type { Block, StoredBlock } from './types'

const SETTLE_MS = 450

export const blockDurationMs = (block: Block): number =>
  block.duration ??
  (block.type === 'text' && block.animation === 'tool'
    ? TOOL_DURATION_MS
    : SETTLE_MS)

type RenderItem =
  | { kind: 'solo'; block: StoredBlock }
  | { kind: 'group'; groupId: string; blocks: StoredBlock[] }

export const groupBlocks = (blocks: StoredBlock[]): RenderItem[] => {
  const out: RenderItem[] = []
  for (const b of blocks) {
    if (b.type === 'text' && b.groupId) {
      const last = out[out.length - 1]
      if (last && last.kind === 'group' && last.groupId === b.groupId) {
        last.blocks.push(b)
        continue
      }
      out.push({ kind: 'group', groupId: b.groupId, blocks: [b] })
    } else {
      out.push({ kind: 'solo', block: b })
    }
  }
  return out
}
